import React, { useState, useEffect } from 'react';
import { navigate } from '@reach/router';
import classes from './like.module.scss';
import Button from '@material-ui/core/Button';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import Favorite from '@material-ui/icons/Favorite';

import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { productInfoFragment } from '../../queries';

const ADD_TO_FAVORITES = gql`
  mutation addToFavorites($id: String!) {
    addToFavorites(productId: $id) {
      ...ProductInfo
    }
  }
  ${productInfoFragment}
`;

const REMOVE_FROM_FAVORITES = gql`
  mutation removeFromFavorites($id: String!) {
    removeFromFavorites(productId: $id) {
      ...ProductInfo
    }
  }
  ${productInfoFragment}
`;

const Like = props => {
  const [active, setActive] = useState(props.isFavorite);
  useEffect(() => {
    setActive(props.isFavorite);
  }, [props.isFavorite]);
  const [addToFavorites] = useMutation(ADD_TO_FAVORITES);
  const [removeFromFavorites] = useMutation(REMOVE_FROM_FAVORITES);

  const [isPopupShown, showPopup] = useState(false);

  const hidePopup = e => {
    showPopup(false);
    e.stopPropagation();
  };

  const navigateToLoginPage = () => {
    navigate('/login');
  };

  return (
    <div
      className={`${classes.like} ${active ? classes.active : ''}`}
      onClick={() => {
        if (localStorage.getItem('token')) {
          if (active) {
            removeFromFavorites({ variables: { id: props.productId } });
          } else {
            addToFavorites({ variables: { id: props.productId } });
          }
          setActive(!active);
        } else {
          showPopup(true);
        }
      }}
    >
      {active ? (
        <Favorite className={classes.icon} />
      ) : (
        <FavoriteBorder className={classes.icon} />
      )}

      <Dialog
        className={classes.likePopup}
        fullWidth={true}
        maxWidth={'xs'}
        open={isPopupShown}
        aria-labelledby="customized-dialog-title"
        onClose={e => hidePopup(e)}
      >
        <div className={classes.contentWrapper}>
          <div className={classes.closeButton}>
            <IconButton aria-label="close" onClick={e => hidePopup(e)}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={classes.likePopupContent}>
            <div>Увійдіть, щоб додати до улюблених</div>
            <Button
              variant="contained"
              color="primary"
              className={classes.writeButton}
              onClick={navigateToLoginPage}
            >
              Увійти
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default Like;
